@if (reportPageView()) {
<section class="tw-px-4 tw-bg-transparent">
  <div class="tw-bg-white tw-rounded-xl tw-shadow-z1 tw-overflow-hidden tw-relative"
       (click)="readMoreAboutDoctor()">
    <div class="tw-relative tw-py-3">
      <div [ngClass]="(regimen().class === appConfig.Shared.Regimen.Class.FACE ? 'tw-bg-orange-100' : 'tw-bg-orange-50')"
           class="tw-absolute tw-top-0 tw-left-0 tw-pr-5 tw-pl-4 tw-py-1 tw-rounded-br-xl tw-w-content tw-flex tw-flex-row tw-items-center tw-gap-2">
        <cs-icon class="tw-w-5 tw-h-5 tw-text-orange-500"
                 [iconName]="'check_circle'"></cs-icon>
        <p class="tw-font-body tw-font-bold tw-text-200 tw-text-orange-400 tw-uppercase"
           *ngIf="appConfig.Shared.Regimen.Class.HAIR === regimen().class"
           i18n="@@yourHairSpecialist"> Your hair specialist </p>
        <p class="tw-font-body tw-font-bold tw-text-200 tw-text-orange-400 tw-uppercase"
           *ngIf="appConfig.Shared.Regimen.Class.FACE === regimen().class"
           i18n="@@yourSkinSpecialist"> Your skin specialist </p>
      </div>
      <div class="tw-flex tw-flex-row tw-items-center tw-gap-1 tw-pl-5 tw-pr-3 tw-justify-between">
        <div class="tw-pt-6">
          <h2 class="tw-font-lexend tw-font-bold tw-text-500 tw-text-gray-900">
            {{allocatedDoctor()?.get('DoctorDisplayName')}}
          </h2>
          <p class="tw-font-body tw-text-200 tw-text-gray-400 tw-mb-2">
            {{conn.getQualifyText(allocatedDoctor())}}
          </p>
          <p class="tw-font-body tw-font-bold tw-text-200 tw-text-gray-900">
            {{allocatedDoctor()?.get('patientsTreated') || 0}}+ patients treated</p>
        </div>
        <img class="tw-flex-none tw-h-[104px] tw-w-[104px] tw-rounded-full tw-bg-green-100 tw-object-contain"
             *ngIf="allocatedDoctor()?.get('DoctorImageThumbnail')"
             [src]="allocatedDoctor().get('doctorDisplayImage')"
             alt="Doctor" />
      </div>
    </div>
  </div>
</section>
} @else {
<section class="tw-h-18 tw-px-4 tw-py-6 "
         [ngClass]="(regimenRehaulV3Exp() ? 'tw-bg-gray-100' : 'tw-bg-white')">
  <div class="tw-bg-white tw-overflow-hidden tw-rounded-xl tw-shadow-z1 tw-relative -tw-mt-24"
       (click)="readMoreAboutDoctor()">
    <div class="tw-relative tw-py-3">
      <div [ngClass]="(regimen().class === appConfig.Shared.Regimen.Class.FACE ? 'tw-bg-orange-100' : 'tw-bg-orange-50')"
           class="tw-pr-5 tw-pl-4 tw-py-1 tw-absolute tw-top-0 tw-left-0 tw-rounded-br-xl tw-w-content tw-flex tw-flex-row tw-items-center tw-gap-2">
        <cs-icon class="tw-w-5 tw-h-5 tw-text-orange-500"
                 [iconName]="'check_circle'"></cs-icon>
        <p class="tw-font-body tw-font-bold tw-text-200 tw-text-orange-400 tw-uppercase"
           *ngIf="appConfig.Shared.Regimen.Class.HAIR === regimen().class"
           i18n="@@yourHairSpecialist"> Your hair specialist </p>
        <p class="tw-font-body tw-font-bold tw-text-200 tw-text-orange-400 tw-uppercase"
           *ngIf="appConfig.Shared.Regimen.Class.FACE === regimen().class"
           i18n="@@yourSkinSpecialist"> Your skin specialist </p>
      </div>
      <div class="tw-flex tw-flex-row tw-items-center tw-gap-1 tw-justify-between tw-pl-5 tw-pr-3">
        <div class="tw-pt-6">
          <h2 class="tw-text-500 tw-text-gray-900 tw-font-body tw-font-bold">
            {{allocatedDoctor()?.get('DoctorDisplayName')}}
          </h2>
          <p class="tw-font-body tw-text-gray-400 tw-text-200 tw-mb-2">
            {{conn.getQualifyText(allocatedDoctor())}}
          </p>
          <p class="tw-text-200 tw-text-gray-900 tw-font-body tw-font-bold">
            {{allocatedDoctor()?.get('patientsTreated') || 0}}+ patients treated</p>
        </div>
        <img class="tw-flex-none tw-bg-green-100 tw-object-contain tw-h-[104px] tw-w-[104px] tw-rounded-full"
             *ngIf="allocatedDoctor()?.get('DoctorImageThumbnail')"
             [src]="allocatedDoctor().get('doctorDisplayImage')"
             alt="Doctor" />
      </div>
    </div>
  </div>
</section>
}